import { useAdministrativeContext } from '../../../../../pages/administrativePanel/administrativePanelContext'
import { useCallback, useEffect, useState } from 'react'
import { FiArrowUpCircle, FiArrowDownCircle } from 'react-icons/fi'
import { RiMoneyDollarCircleLine, RiCoinsLine} from 'react-icons/ri'
import { toast } from 'react-toastify'
import { api } from '../../../../../services/api'
import { SpaceLoader } from '../../../../loaders/spaceLoader'
import { FormatMoney } from '../../formatMoney'
import { useAuth } from '../../../../../context/AuthContext'
import { useDispatch } from 'react-redux'

import { BarChart, Bar, XAxis, Tooltip, ResponsiveContainer,CartesianGrid} from 'recharts'

import { Container, CardFinancialSummary,GroupSummary,ContainerFinancialSummary,ContainerTotalSummary} from './style'

export function FinancialSummary() {
    const [financialSummaryDatas, setFinancialSummaryData] = useState({});
    const [groupSummaryDatas,setGroupSummaryDatas] = useState({});
    const [groupSelected,setGroupSelected] = useState('');
    const [groups,setGroups] = useState([]);

    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingGroup,setIsLoadingGroup] = useState(true);

    const { 
        startDate, 
        endDate, 
        listBusinessToFilter,
        listSalesChannelsId 
    } = useAdministrativeContext()
    
    const { signOut } = useAuth()
    const dispatch = useDispatch()

    useEffect(() => {
        setGroupSelected('');
    },[listBusinessToFilter])
    
    const fetchData = useCallback(async () => {
        setIsLoading(true)
        let obj = {
            startDate: startDate,
            endDate: endDate,
            business: listBusinessToFilter,
            salesChannels: listSalesChannelsId
        }
        
        
        try{
            await api.post('/getFinancialSummary' , obj, {
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('@Inoveclube:token')
                }
            }).then(response => {
                setFinancialSummaryData(response.data)
            })
            setIsLoading(false)

        }catch(error){
            if(error.response){
                if(error.response.status === 401 || error.response.status === 500){
                    signOut()
                    toast.warning('Sua sessão foi expirada')
                }else{
                    toast.error(error.response.data.message)
                }
            }else{
                toast.error(error.message)
            }        
        }
    }, [endDate, signOut, startDate, listBusinessToFilter, listSalesChannelsId]);
    
    useEffect(() => {
        if(startDate !== '' && endDate !== ''){
            fetchData()
        }

        return () => {
            setFinancialSummaryData({})
        }

    }, [fetchData, startDate, endDate]);

    const getAllGroups = useCallback(async () => {
        let obj = {
            business: listBusinessToFilter
        }

        try {
            const response = await api.post('/getAllGroups', obj, {
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('@Inoveclube:token')
                }
            })
            setGroups(response.data.groups)
        } 
        catch(error){
            toast.error('Erro ao pegar todos os grupos !')
        }
    },[listBusinessToFilter]);
    

    const getBestSellingGroupProduct = useCallback(async () => {
        setIsLoadingGroup(true);

        let obj = {
            business: listBusinessToFilter,
            salesChannels: listSalesChannelsId,
            groupSelected: groupSelected
        }
    
        try {
            const response = await api.post('/getBestSellingGroup',obj,
            {
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('@Inoveclube:token')
                }
            })

            if(response.data.success === 0){
                setGroupSummaryDatas({});
                setIsLoadingGroup(false);
                return
            }
            //console.log(response.data)

            const arr = response.data?.productsMinutes?.map((value) => {
                return{
                    quantTotal: response.data.fracionado ? Number(value.quantTotal).toFixed(2) : value.quantTotal
                }
            })

            setGroupSummaryDatas({...response.data, arr});
            //console.log({...response.data, arr})
            setIsLoadingGroup(false);
        }
        catch(error){
            //console.log(error.response.data)
            toast.error('Erro ao carregar o grupo mais vendido !');
            setIsLoadingGroup(false);
        }
    },[listBusinessToFilter,listSalesChannelsId,groupSelected]);

    useEffect(async () => {
        if(startDate !== '' && endDate !== ''){
            getAllGroups();
            getBestSellingGroupProduct()
        }

        return () => {
            setGroupSummaryDatas({})
        }
    },[getBestSellingGroupProduct,getAllGroups,startDate, endDate]);

    return(
        <Container>
            <ContainerFinancialSummary>
            <CardFinancialSummary 
                className="green" 
                onClick={() => dispatch({
                    type: 'OPEN_CENTRALIZEDMODAL', 
                    title: "Receitas", 
                    componentToShow: 'earningsList',
                    datasComponent: { 
                        endDate, 
                        startDate, 
                        business: listBusinessToFilter,
                        salesChannels: listSalesChannelsId
                    } 
                })}>
                <div className='container-result'>
                    <header>
                        <p>RECEITAS</p>
                        <FiArrowUpCircle />
                    </header>
                
                    <strong>
                        { 
                            isLoading ? 
                            <SpaceLoader colorLoader="#FFF" /> 
                            :
                            <FormatMoney value={financialSummaryDatas.credits}/>
                        }
                    </strong>
                </div>
            </CardFinancialSummary>

            <CardFinancialSummary 
                    className="red"                 
                    onClick={() => dispatch({
                            type: 'OPEN_CENTRALIZEDMODAL', 
                            title: "Despesas", 
                            componentToShow: 'expensesList',
                            datasComponent: { 
                                endDate, 
                                startDate, 
                                business: listBusinessToFilter,
                                salesChannels: listSalesChannelsId
                            } 
                    })}
                >
                <div className='container-result'>
                    <header>
                        <p>DESPESAS</p>
                        <FiArrowDownCircle />
                    </header>

                    <strong>
                        { 
                            isLoading ? 
                            <SpaceLoader colorLoader="#FFF" /> 
                            :
                            <FormatMoney value={financialSummaryDatas.debts}/>
                        }
                    </strong>
                </div>
            </CardFinancialSummary>
            </ContainerFinancialSummary>
            
            <ContainerTotalSummary>
            <CardFinancialSummary className="gray">
                <header>
                    <p>SALDO</p>
                    <RiMoneyDollarCircleLine />
                </header>

                <strong>
                    { 
                        isLoading ? 
                        <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" /> 
                        :
                        <FormatMoney value={financialSummaryDatas.balance} />
                    }
                </strong>
            </CardFinancialSummary>

            <CardFinancialSummary className="gray">
                <header>
                    <p>Pedidos</p>
                    <p className="svgTicket"> 
                        <RiCoinsLine /> Ticket Médio
                    </p>
                </header>
                
                    <div className="salesAndTicket">
                    { 
                        isLoading ? 
                        <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" /> 
                        :
                        <>
                            <strong>
                            
                                <p>
                                    {
                                        
                                        financialSummaryDatas.countSales >= 1000000 && financialSummaryDatas.countSales < 1000000000 ? 
                                        `${Math.ceil(financialSummaryDatas.countSales/1000000)}M` :
                                        financialSummaryDatas.countSales >= 1000000000 ? 
                                        `${Math.ceil(financialSummaryDatas.countSales/1000000000)}B` :      
                                        financialSummaryDatas.countSales
                                        
                                    }
                                </p>

                            </strong>

                            <strong>
                            
                                <FormatMoney value={financialSummaryDatas.ticket} />
                            
                            </strong>
                        </>
                        }
                    </div>
            </CardFinancialSummary>

            <GroupSummary>
                    <header>
                        {
                            isLoadingGroup ?
                                <p>Carregando grupo...</p>
                            :
                            <>
                                <p>Vendas nos últimos 30 minutos</p>

                                <p className='quant'>
                                    {
                                        groupSummaryDatas?.productsMinutes ?
                                            groupSummaryDatas?.productsMinutes?.map((value) => {
                                                return value.quantTotal
                                            }).reduce((value,next) => {
                                                return value + next
                                            }).toFixed(2) + ` ${groupSummaryDatas?.unidade}`
                                        :
                                        0
                                    }
                                </p>
                            </>
                        }
                    </header>
                    
                    {
                        isLoadingGroup ? 
                        <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" /> 
                        :
                        <>
                        <ResponsiveContainer  width="100%" height="100%" maxHeight={150}>
                            <BarChart
                                data={groupSummaryDatas.arr}
                                margin={{top: 30}}
                            >
                                <Tooltip />
                                
                                <XAxis 
                                    dataKey="dataEmissao" 
                                    tick={() => ''}
                                    axisLine={false} 
                                    tickLine={false} 
                                />
                                

                                <Bar 
                                    dataKey="quantTotal" 
                                    fill="#2e9699"  
                                />
                            </BarChart>
                        </ResponsiveContainer>

                        <select 
                            value={groupSelected !== '' ? groupSelected : groupSummaryDatas.group} 
                            onChange={(event) => setGroupSelected(event.target.value)} 
                            className="select"
                        >
                        <option value='' disabled>Selecione um grupo</option>
                        {
                            groups.map((group, index) => {
                                return(
                                    <option value={group.grupo} key={index}>
                                        {group.grupo}
                                    </option>
                                )
                            })
                        }
                        </select>
                        </>
                    }
            </GroupSummary>

            </ContainerTotalSummary>
        </Container>
    )
}